import { createApp } from 'vue'
import App from './App.vue'
// import store from './store'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
// 引用公用文件
import api from './utils/apiAxios.js'
const app = createApp(App);


// 将API方法绑定到全局
app.config.globalProperties.$api = api;
app.config.productionTip = false;

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    const role = localStorage.getItem('token');
    if (!role && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
    // if(to.path === '/register'){
    //   next();
    // }else if (!role && to.path !== '/login') {
    //   next('/login');
    // }else {
    //   next();
    // }
    // else if (to.meta.permission) {
    //   // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    //   role === 'admin'
    //     ? next()
    //     : next('/403');
    // }
});



app.use(router)
    .use(ElementPlus)
// app.mounted(() => {
//     document.dispatchEvent(new Event('render-event'))
// })
app.mount('#app')